import React from "react";
import "./UiStarBadge.css";
import UiIcon from "../UiIcon";
import { ICON } from "../../../assets";

function UiStarBadge({ content, confirmationIcon, disabled }) {
  return (
    <React.Fragment>
      <div className={`star-badge${disabled ? " disabled" : ""}`}>
        <span className={`star-badge__text${disabled ? " disabled-text" : ""}`}>
          {content}
        </span>
        {confirmationIcon && !disabled && (
          <UiIcon
            className="star-badge__icon"
            icon={ICON.confirmationPinkIcon}
            size="lg"
          />
        )}
        <UiIcon
          className="star-badge__content"
          icon={disabled ? ICON.starDisbledIcon : ICON.starIcon}
          size="lg"
        />
      </div>
    </React.Fragment>
  );
}

export default UiStarBadge;
